const especialTaxTypeList = [
  {
    value: 0,
    label: "Sem regime de tributação especial",
    ENUM: "SEM_REGIME_TRIBUTARIO_ESPECIAL",
  },
  {
    value: 1,
    label: "Micro empresa Municipal",
    ENUM: "MICRO_EMPRESA_MUNICIPAL",
  },
  { value: 2, label: "Estimativa", ENUM: "ESTIMATIVA" },
  {
    value: 3,
    label: "Sociedade de Profissionais",
    ENUM: "SOCIEDADE_DE_PROFISSIONAIS",
  },
  { value: 4, label: "Cooperativa", ENUM: "COOPERATIVA" },
  {
    value: 5,
    label: "Micro empresário individual-MEI",
    ENUM: "MICROEMRPESARIO_INDIVIDUAL_MEI",
  },
  {
    value: 6,
    label: "Microempresa ou Pequeno Porte - ME EPP",
    ENUM: "MICROEMPRESA_OU_PEQUENO_PORTE",
  },
  { value: 7, label: "Lucro Real", ENUM: "LUCRO_REAL" },
  { value: 8, label: "Lucro Presumido", ENUM: "LUCRO_PRESUMIDO" },
  { value: 9, label: "Tributacao Normal", ENUM: "TRIBUTACAO_NORMAL" },
  {
    value: 10,
    label: "Simples Nacional com Excesso do Sublimite",
    ENUM: "SIMPLES_NACIONAL_COM_EXCESSO_DO_SUBLIMITE",
  },
  {
    value: 11,
    label: "Empresa de responsabilidade limitada",
    ENUM: "EMPRESA_DE_RESPONSABILIDADE_LIMITADA",
  },
];

export default especialTaxTypeList;
